import { useEffect, useState } from 'react';
import Portal from '../Portal';
import cn from 'classnames';
import './Modal.scss';

/**
 * 
 * @param {{
 *   open?: boolean;
 *   onDismiss?: () => void;
 *   noPadding: false;
 *   children: React.ReactNode;
 * }} param0 
 * @returns 
 */
const Modal = ({
  open,
  children,
  noPadding = false,
  onDismiss,
}) => {
  const [ id ] = useState(() => crypto.getRandomValues(new Uint8Array(4)).reduce((str, b) => {
    const hex = ('0' + b.toString(16)).slice(-2);
    return `${str}${hex}`;
  }, 'c'));

  // Adding/removing no scroll class when modal is open/closed
  useEffect(() => {
    if (!open) return;
    const els = [document.documentElement, document.body];
    for (const el of els) {
      el.classList.add(`${id}-no-scroll`);
    }
    
    return () => {
      for (const el of els) {
        el.classList.remove(`${id}-no-scroll`);
      }
    }
  }, [open]);

  return (
    <Portal element="#modal-root">
      <div className={cn({
        'XModal': true,
        'XModal--open': !!open,
      })}>
        <style dangerouslySetInnerHTML={{__html: `
          body.${id}-no-scroll, html.${id}-no-scroll {
            overflow: hidden;
            height: 100vh;
          }
        `}}/>
        <div className="XModal__Vignette" onClick={onDismiss} />
        <div className={cn({
          'XModal__Main': true,
          'XModal__Main--no-padding': noPadding,
        })}>
          {children}
          <div className="XModal__Spacer" />
        </div>
      </div>
    </Portal>
  )
}

export default Modal;